export default {
    beforeDestroy() {
        this.hideModal();
    },

    methods: {
        onModalHidden() {
            this.$emit('modal-hidden');
        },

        onModalShown() {},

        beforeShowModal() {},

        showModal() {
            this.beforeShowModal();

            $(this.$el)
                .on('shown.bs.modal', e => {
                    this.$emit('modal-shown');
                    this.onModalShown();
                })
                .modal('show');
        },

        hideModal() {
            $(this.$el).modal('hide');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/modals.js